import React from "react";
import { useLocation } from "react-router-dom";
import { ThemeToggle } from "@/components/theme-toggle";
import { TITULOS_DAS_TELAS } from "@/lib/titulos-das-telas";

interface MobileHeaderProps {
  title?: string;
  subtitle?: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  subtitle,
}) => {
  const location = useLocation();

  const getPageTitle = (): string => {
    if (title) return title;
    return TITULOS_DAS_TELAS[location.pathname]?.title || "Dashboard";
  };

  const getPageSubtitle = (): string => {
    if (subtitle) return subtitle;
    return TITULOS_DAS_TELAS[location.pathname]?.subtitle || "";
  };

  return (
    <div className="lg:hidden fixed top-0 left-0 right-0 z-[9999] bg-background border-b border-border shadow-sm">
      <div className="flex items-center justify-between h-16 px-4">
        {/* Logo e marca */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <div className="relative">
              <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">P</span>
              </div>
              <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-700 rounded-sm"></div>
            </div>
            <div className="flex flex-col">
              <span className="text-primary font-medium text-sm leading-none">
                painel
              </span>
              <span className="text-muted-foreground text-xs leading-none">
                DO E-COMMERCE
              </span>
            </div>
          </div>
        </div>

        {/* Título da página */}
        <div className="flex-1 text-right pr-4">
          <h1 className="text-lg font-semibold text-foreground truncate">
            {getPageTitle()}
          </h1>
          {getPageSubtitle() && (
            <p className="text-xs text-muted-foreground truncate">
              {getPageSubtitle()}
            </p>
          )}
        </div>

        {/* Botão de tema */}
        <div className="flex items-center">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
};
